import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {createEffect, Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as fromApp from './../../../store/app.reducers';

import * as CertificateActions from './certificate.actions';
import * as ProfileActions from '../../store/profile.actions';
import * as ErrorActions from '../../../error/store/error.actions';

import {HttpErrorResponse} from '@angular/common/http';
import {Certificate} from '../certificate.model';
import {CertificateService} from '../certificate.service';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class CertificateEffects {

  getCertificateProfile = createEffect(() => this.actions$
    .pipe(
      ofType(CertificateActions.GET_CERTIFICATE_PROFILE),
      map(
        (data: {type: string, payload: {id: number, redirect: boolean}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, redirect: boolean}) => {
          return this.certificateService.getCertificateForAudit(param.id).pipe(
            mergeMap(
              (response: Certificate) => {
                if (param.redirect) {
                  // this.router.navigate(['audit/certificate', param.id, response.code]);
                  this.router.navigate(['/c', response.code]);
                }
                return [{
                  type: CertificateActions.SET_CERTIFICATE,
                  payload: response
                }, {
                  type: ProfileActions.SET_AUDIT_ID,
                  payload: {
                    id: response.audit_id
                  }
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getCertificateByCode = createEffect(() => this.actions$
    .pipe(
      ofType(CertificateActions.GET_CERTIFICATE_PROFILE_BY_CODE),
      map(
        (data: {type: string, payload: {code: string}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {code: string}) => {
          return this.certificateService.getCertificateByCode(param.code).pipe(
            mergeMap(
              (response: Certificate) => {
                return [{
                  type: CertificateActions.SET_CERTIFICATE,
                  payload: response
                }, {
                  type: CertificateActions.ADD_CERTIFICATE_VIEW,
                  payload: {
                    code: response.code
                  }
                }, {
                  type: ProfileActions.SET_AUDIT_ID,
                  payload: {
                    id: response.audit_id
                  }
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  addCertificateView = createEffect(() => this.actions$
    .pipe(
      ofType(CertificateActions.ADD_CERTIFICATE_VIEW),
      map(
        (data: {type: string, payload: {code: string}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {code: string}) => {
          return this.certificateService.addCertificateView(param.code).pipe(
            tap(
              (response: any) => {

              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  constructor(
    private actions$: Actions,
    private certificateService: CertificateService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>
  ) {}
}
